// src/components/SyncSpinnerModal.jsx
import React from 'react';
import './SyncSpinnerModal.css';

export default function SyncSpinnerModal({ open = false, message = "sync’ing shopping carts, please wait…" }) {
  if (!open) return null;
  return (
    <div className="ssm-overlay">
      <div className="ssm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="ssm-spinner" aria-hidden="true" />
        <div className="ssm-text" role="status" aria-live="polite">
          {message}
        </div>
      </div>
    </div>
  );
}